export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvImg.vue?vue&type=template&id=44bcec5e&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvImg.vue?vue&type=template&id=44bcec5e&lang=pug&
// module id = 160
// module chunks = 0 1